import { EmailAddress } from '@dreryk/email-address-common-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { EmailAddressInput as EmailAddressInputComponent } from '@dreryk/react-components';

export type FirstNameValue = { firstName: string | null };
export type EmailAddressValue = { emailAddress: EmailAddress | null };
type EmailAddressInputProps = Pick<FormContextValues<EmailAddressValue>, 'register'>;

export const EmailAddressInput = (props: EmailAddressInputProps): JSX.Element => {
   const controller = props.register('emailAddress');

   return (
      <EmailAddressInputComponent
         testId={'emailAddress'}
         controller={controller}
         label={commonTranslationKeys.email}
         disabled
      />
   );
};
